/* ============================================================
   OSZEA — Size Guide section script (bundled, self-contained)
   Handles: scroll-reveal, smooth-scroll, FAQ accordion, AND the
   SHOE-MASTER wizard + size-chart tabs + fit troubleshooting.
   No theme dependencies. Drop in theme/assets/oszea-size-guide.js
   ============================================================ */
(function () {
  'use strict';
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll reveal ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---- smooth scroll for in-page anchors ---- */
  $$('[data-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      var t = document.querySelector(href);
      if (!t) return;
      e.preventDefault();
      var y = t.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    });
  });

  /* ---- FAQ accordion ---- */
  $$('.faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q'), a = item.querySelector('.faq-a');
    if (!q || !a) return;
    q.addEventListener('click', function () {
      var open = item.classList.contains('open');
      $$('.faq-item.open').forEach(function (o) { if (o !== item) { o.classList.remove('open'); var oa = o.querySelector('.faq-a'); if (oa) oa.style.maxHeight = '0px'; } });
      item.classList.toggle('open', !open);
      a.style.maxHeight = !open ? a.scrollHeight + 'px' : '0px';
    });
  });
  window.addEventListener('resize', function () {
    var open = document.querySelector('.faq-item.open'); if (open) { var a = open.querySelector('.faq-a'); if (a) a.style.maxHeight = a.scrollHeight + 'px'; }
  }, { passive: true });
})();


/* ============================================================
   OSZEA — Size Guide
   SHOE-MASTER Recommendation wizard · product/size-chart tabs ·
   troubleshooting accordion. Vanilla JS, Shopify-friendly.
   Loads alongside support-pages.js (shared chrome, reveal, FAQ,
   smooth-scroll, toast, rain canvases).

   DEVELOPER: all sizing comes from the <script id="sizeData"> JSON
   block in the page (mirror of OSZEA's editable size charts). No
   measurements are hardcoded in this file. Swap the JSON for a
   Shopify metafield / section-setting render and the tool keeps
   working unchanged.
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Load size data ---------- */
  var DATA = {};
  try {
    var raw = $('#sizeData');
    if (raw) DATA = JSON.parse(raw.textContent);
  } catch (e) { DATA = {}; }

  /* product → which gender datasets exist */
  function genderKeys(prod) {
    var p = DATA[prod] || {};
    return Object.keys(p);
  }

  /* =========================================================
     SHOE-MASTER WIZARD
     ========================================================= */
  var wiz = $('#shoeMaster');
  if (wiz) initWizard(wiz);

  function initWizard(root) {
    var STEPS = ['product', 'who', 'usual', 'foot', 'fit', 'width'];
    var state = { product: '', who: '', usual: '', eu: '', uk: '', foot: '', unit: 'cm', fit: 'regular', width: 'regular' };
    var idx = 0;

    var stepEls = $$('.sm-step', root);
    var railItems = $$('.sm-steplist li', root);
    var progFill = $('.sm-mprog-fill', root);
    var progNow = $('.sm-mprog-now', root);
    var progTot = $('.sm-mprog-tot', root);
    var backBtn = $('.sm-back', root);
    var nextBtn = $('.sm-next', root);
    var stepsWrap = $('.sm-steps', root);
    var resultEl = $('.sm-result', root);

    if (progTot) progTot.textContent = STEPS.length;

    /* keep who-options in sync with product (kids forces kids) */
    function syncWho() {
      var keys = genderKeys(state.product);
      var kidsOnly = keys.length === 1 && keys[0] === 'kids';
      $$('.sm-opt[data-step="who"] input', root).forEach(function (inp) {
        var v = inp.value;
        var allowed = keys.indexOf(v) !== -1;
        inp.disabled = !allowed;
        var card = inp.closest('.sm-opt');
        if (card) card.classList.toggle('is-disabled', !allowed);
        if (!allowed && inp.checked) { inp.checked = false; state.who = ''; }
      });
      if (kidsOnly) {
        var kidsInp = $('.sm-opt[data-step="who"] input[value="kids"]', root);
        if (kidsInp) { kidsInp.checked = true; state.who = 'kids'; }
      }
      // usual-size label hint
      var hint = $('#smUsualHint', root);
      if (hint) {
        hint.textContent = state.who === 'kids'
          ? 'Enter the kids US / AU size your child usually wears.'
          : 'Enter the ' + (state.who || 'adult') + ' US / AU / NZ size you usually wear.';
      }
    }

    /* render which step is visible */
    function render() {
      stepEls.forEach(function (el, i) { el.classList.toggle('active', i === idx); });
      railItems.forEach(function (li, i) {
        li.classList.toggle('active', i === idx);
        li.classList.toggle('done', i < idx);
      });
      if (progFill) progFill.style.width = ((idx + 1) / STEPS.length * 100) + '%';
      if (progNow) progNow.textContent = idx + 1;
      backBtn.classList.toggle('show', idx > 0);
      nextBtn.textContent = idx === STEPS.length - 1 ? 'See my size' : 'Next';
      var arw = nextBtn.querySelector('.arw'); if (!arw) nextBtn.insertAdjacentHTML('beforeend', ' <span class="arw">→</span>');
      // focus first control for a11y
      var active = stepEls[idx];
      var f = active && active.querySelector('input, select');
      if (f && !f.disabled) { try { f.focus({ preventScroll: true }); } catch (e) {} }
    }

    /* validation per step */
    function valid() {
      var key = STEPS[idx];
      if (key === 'product') return !!state.product;
      if (key === 'who') return !!state.who;
      if (key === 'usual') return true;  // optional — foot length is the strong signal
      if (key === 'foot') {
        if (!state.usual && !state.foot) { flash('Add your usual size or a foot length to continue.'); return false; }
        return true;
      }
      return true;
    }
    function flash(msg) {
      var fl = $('.sm-flash', root);
      if (!fl) return;
      fl.textContent = msg; fl.classList.add('show');
      clearTimeout(fl._t); fl._t = setTimeout(function () { fl.classList.remove('show'); }, 3200);
    }

    /* ---- option selection ---- */
    $$('.sm-opt input', root).forEach(function (inp) {
      inp.addEventListener('change', function () {
        var step = inp.getAttribute('name');
        state[step] = inp.value;
        if (step === 'product') syncWho();
        // auto-advance on single-choice product/who/fit/width after a beat
      });
    });

    /* unit toggle */
    $$('.sm-unit button', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.sm-unit button', root).forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        state.unit = b.getAttribute('data-unit');
        var fi = $('#smFoot', root);
        if (fi) fi.placeholder = state.unit === 'mm' ? 'e.g. 265' : 'e.g. 26.5';
      });
    });

    /* text inputs */
    var bind = function (id, key) { var el = $(id, root); if (el) el.addEventListener('input', function () { state[key] = el.value.trim(); }); };
    bind('#smUsual', 'usual'); bind('#smEu', 'eu'); bind('#smUk', 'uk'); bind('#smFoot', 'foot');

    /* nav */
    nextBtn.addEventListener('click', function () {
      if (!valid()) return;
      if (idx < STEPS.length - 1) { idx++; render(); scrollTop(); }
      else { compute(); }
    });
    backBtn.addEventListener('click', function () { if (idx > 0) { idx--; render(); scrollTop(); } });
    function scrollTop() {
      if (window.matchMedia('(max-width: 820px)').matches) {
        var top = root.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    /* rail click → jump to a completed/earlier step */
    railItems.forEach(function (li, i) {
      li.addEventListener('click', function () { if (i <= idx) { idx = i; render(); } });
    });

    /* =====================================================
       RECOMMENDATION ENGINE
       Foot length is the primary signal; usual size is the
       fallback. Fit + width preferences nudge the result.
       Wording is "Recommended starting size" — never a
       guaranteed/medical fit.
       ===================================================== */
    function footToCm() {
      if (!state.foot) return null;
      var n = parseFloat(state.foot);
      if (isNaN(n)) return null;
      if (state.unit === 'mm' || n > 60) n = n / 10;  // treat big numbers as mm
      return n;
    }

    function rows() {
      var p = DATA[state.product] || {};
      var who = state.who && p[state.who] ? state.who : Object.keys(p)[0];
      return { list: p[who] || [], who: who };
    }

    function compute() {
      var r = rows();
      var list = r.list;
      if (!list.length) { flash('Sizing data unavailable — please message us for help.'); return; }

      var cm = footToCm();
      var baseIdx = -1;
      var ranged = false;

      if (cm != null) {
        // first row whose foot-length capacity >= measured foot
        for (var i = 0; i < list.length; i++) {
          if (parseFloat(list[i].cm) >= cm - 0.01) { baseIdx = i; break; }
        }
        if (baseIdx === -1) baseIdx = list.length - 1;   // longer than chart → largest
        // between sizes? measured foot sits >3mm below the chosen row's capacity
        var cap = parseFloat(list[baseIdx].cm);
        if (baseIdx > 0) {
          var prevCap = parseFloat(list[baseIdx - 1].cm);
          if (cm > prevCap + 0.05 && cm < cap - 0.25) ranged = true;
        }
      } else if (state.usual) {
        // match usual US/AU size against chart
        var u = (state.usual + '').replace(/[^0-9.]/g, '');
        for (var j = 0; j < list.length; j++) {
          if ((list[j].ausus + '') === u) { baseIdx = j; break; }
        }
        if (baseIdx === -1) {
          // nearest numeric
          var target = parseFloat(u), best = 99, bi = 0;
          list.forEach(function (row, k) { var d = Math.abs(parseFloat(row.ausus) - target); if (d < best) { best = d; bi = k; } });
          baseIdx = bi; ranged = true;
        }
      }

      if (baseIdx === -1) baseIdx = Math.min(2, list.length - 1);

      // preference nudges
      var pickIdx = baseIdx;
      var note = '';
      if (state.fit === 'room' || state.fit === 'snug') { /* handled in copy */ }
      if (state.fit === 'room' && ranged) { pickIdx = Math.min(list.length - 1, baseIdx + 1); }
      if (state.fit === 'snug' && ranged) { pickIdx = baseIdx; }

      var row = list[pickIdx];
      var upRow = list[Math.min(list.length - 1, pickIdx + 1)];

      // ---- fit note copy ----
      var prodName = $('#sizeData') ? (DATA._labels && DATA._labels[state.product]) : state.product;
      prodName = prodName || labelFor(state.product);
      var whoLabel = r.who === 'kids' ? 'Kids' : (r.who.charAt(0).toUpperCase() + r.who.slice(1));

      var bits = [];
      if (cm != null) bits.push('a ' + cm.toFixed(1) + ' cm foot length');
      else if (state.usual) bits.push('your usual size ' + state.usual);
      bits.push(state.fit === 'snug' ? 'a snug fit' : state.fit === 'room' ? 'room for thicker socks' : 'a regular fit');
      var basis = bits.join(', ');

      if (state.width === 'wide') {
        note = 'You told us you have wider feet. This starting size is based on your foot length — if you like extra room across the foot, consider the next size up and use the 30-day exchange if needed.';
      } else if (state.fit === 'room') {
        note = 'Because you want room for thicker socks, we’ve leaned toward the more generous size. If it feels loose with thin socks, the size below will be snugger.';
      } else if (ranged) {
        note = 'Your foot length sits between two sizes. We’ve recommended a starting size — size down for a snug fit, or up for more room.';
      } else {
        note = 'This is a confident match for your measurements. If you’re ever between fits, foot length is the most reliable guide.';
      }

      renderResult({
        row: row, upRow: upRow, whoLabel: whoLabel, prodKey: state.product,
        prodName: prodName, basis: basis, note: note, ranged: ranged, cm: cm
      });
    }

    function labelFor(key) {
      return ({ tasman: 'Tasman Essentials', urban: 'Urban Essentials', kids: 'Kids Melbourne Chelsea' })[key] || key;
    }

    function renderResult(o) {
      stepsWrap.style.display = 'none';
      $('.sm-mprog', root).style.display = 'none';
      $('.sm-nav', root).style.display = 'none';
      railItems.forEach(function (li) { li.classList.add('done'); li.classList.remove('active'); });

      var sizeLine = o.whoLabel + ' ' + o.row.ausus;
      $('#smResWho', root).textContent = o.ranged ? 'Recommended starting size range' : 'Recommended starting size';
      $('#smResSize', root).innerHTML = o.ranged
        ? '<span class="sm-rs-em">' + o.whoLabel + ' ' + o.row.ausus + '</span>–' + o.upRow.ausus
        : '<span class="sm-rs-em">' + o.whoLabel + ' ' + o.row.ausus + '</span>';
      $('#smResProd', root).innerHTML = 'for <b>' + o.prodName + '</b>';

      $('#smConvUs', root).textContent = o.row.ausus;
      $('#smConvUk', root).textContent = o.row.uk;
      $('#smConvEu', root).textContent = o.row.eu;
      $('#smConvCm', root).textContent = o.row.cm + ' cm';

      $('#smResNote', root).innerHTML = o.note;

      // result CTAs → matching shop link + label
      var shop = $('#smShopCta', root);
      if (shop) {
        shop.textContent = 'Shop ' + o.prodName + ' →';
        var shopMap = (DATA._shop) || { tasman: 'Tasman Essentials.html', urban: 'Urban Essentials.html', kids: 'Kids Melbourne Chelsea.html' };
        shop.setAttribute('href', shopMap[o.prodKey] || '#');
      }

      resultEl.classList.add('show');

      // jump the size-chart explorer to the matching product/gender + highlight
      highlightChart(o.prodKey, o.whoLabel.toLowerCase(), o.row.ausus);

      // reveal sticky help on mobile
      var sticky = $('#stickyHelp'); if (sticky) sticky.classList.add('show');
    }

    /* restart */
    $('.sm-restart', root).addEventListener('click', function () {
      idx = 0;
      state = { product: '', who: '', usual: '', eu: '', uk: '', foot: '', unit: 'cm', fit: 'regular', width: 'regular' };
      $$('.sm-opt input', root).forEach(function (i) { i.checked = false; i.disabled = false; });
      $$('.sm-opt', root).forEach(function (c) { c.classList.remove('is-disabled'); });
      $$('#shoeMaster input[type="text"], #shoeMaster input[type="number"]').forEach(function (i) { i.value = ''; });
      // default fit/width back to regular
      var fr = $('.sm-opt input[name="fit"][value="regular"]', root); if (fr) fr.checked = true; state.fit = 'regular';
      var wr = $('.sm-opt input[name="width"][value="regular"]', root); if (wr) wr.checked = true; state.width = 'regular';
      resultEl.classList.remove('show');
      stepsWrap.style.display = '';
      $('.sm-mprog', root).style.display = '';
      $('.sm-nav', root).style.display = '';
      render();
      var top = root.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });

    // defaults
    var fr0 = $('.sm-opt input[name="fit"][value="regular"]', root); if (fr0) fr0.checked = true;
    var wr0 = $('.sm-opt input[name="width"][value="regular"]', root); if (wr0) wr0.checked = true;
    render();
  }

  /* =========================================================
     SIZE-CHART EXPLORER — product tabs + gender toggle
     ========================================================= */
  var explorer = $('#sgExplorer');
  if (explorer) {
    var tabs = $$('.sg-tab', explorer);
    var panels = $$('.sg-panel', explorer);
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { selectTab(i); });
      t.addEventListener('keydown', function (e) {
        var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : -1;
        if (n >= 0 && n < tabs.length) { e.preventDefault(); tabs[n].focus(); selectTab(n); }
      });
    });
    function selectTab(i) {
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
      panels.forEach(function (p, k) { p.classList.toggle('active', k === i); });
    }
    // gender toggle within each panel
    $$('.sg-gender', explorer).forEach(function (g) {
      $$('button', g).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('button', g).forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          var gk = b.getAttribute('data-gender');
          var panel = b.closest('.sg-panel');
          $$('.sg-genderpane', panel).forEach(function (pane) {
            pane.classList.toggle('on', pane.getAttribute('data-gender') === gk);
          });
        });
      });
    });
  }

  /* jump explorer to matching product/gender + highlight a size row */
  function highlightChart(prodKey, whoKey, ausus) {
    var explorer = $('#sgExplorer');
    if (!explorer) return;
    // key-based lookup so products can be reordered in the theme editor
    var panel = $('.sg-panel[data-prodkey="' + prodKey + '"]', explorer);
    if (!panel) {
      var fallback = { tasman: 0, urban: 1, kids: 2 }[prodKey];
      panel = $$('.sg-panel', explorer)[fallback];
    }
    if (!panel) return;
    var tab = $('#' + (panel.getAttribute('aria-labelledby') || ''), explorer);
    if (tab) tab.click();
    // gender
    var g = $('.sg-gender', panel);
    if (g) {
      var gb = $('button[data-gender="' + (whoKey === 'kids' ? 'kids' : whoKey) + '"]', g);
      if (gb) gb.click();
    }
    var pane = $('.sg-genderpane.on', panel) || $('.sg-genderpane', panel);
    if (!pane) return;
    $$('tr', pane).forEach(function (tr) { tr.classList.remove('sg-hl'); });
    $$('tbody tr', pane).forEach(function (tr) {
      var c = tr.querySelector('td');
      var label = c && c.childNodes[0] ? (c.childNodes[0].nodeValue || '').trim() : '';
      if (label === (ausus + '')) tr.classList.add('sg-hl');
    });
  }

  /* =========================================================
     TROUBLESHOOTING — decision accordion cards
     ========================================================= */
  $$('.sg-tcard').forEach(function (card) {
    var q = $('.sg-tcard-q', card), a = $('.sg-tcard-a', card);
    if (!q || !a) return;
    q.addEventListener('click', function () {
      var open = card.classList.contains('open');
      card.classList.toggle('open', !open);
      q.setAttribute('aria-expanded', !open ? 'true' : 'false');
      a.style.maxHeight = !open ? a.scrollHeight + 'px' : '0px';
    });
  });
  window.addEventListener('resize', function () {
    $$('.sg-tcard.open .sg-tcard-a').forEach(function (a) { a.style.maxHeight = a.scrollHeight + 'px'; });
  }, { passive: true });

  $$('.sg-fit-chart-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var prodKey = btn.getAttribute('data-prodkey');
      if (prodKey) highlightChart(prodKey, null, null);
    });
  });

})();
